import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button, Card, Input, List, Select, Space, Table, Typography} from "antd";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";

export default function CashRegisterList()
{
    const history = useHistory();
    const [cashRegister, setCashRegister] = useState([]);
    const [filteredData, setFilteredData] = useState([])

    const getCashRegisters = async () => {
        const res = await ApiService.CashRegister.GetCashRegisters(true)

        if(res.success)
        {
            setCashRegister(res.data)
        }
    }

    useEffect(() => {
        getCashRegisters()
    }, [])

    useEffect(() => {
        setFilteredData(cashRegister)
    }, [cashRegister])

    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Space style={{marginBottom: 16}}>
                    <Button size={'small'} onClick={() => {history.push(`/app/system/cash-registers/create`)}} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getCashRegisters}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if(!e.target.value)
                            {
                                setFilteredData(cashRegister);
                                return
                            }
                            setFilteredData([...filteredData.filter(x => x.name.toLowerCase().includes(e.target.value.toLowerCase()))])
                        }}
                    />
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    columns={[
                        {dataIndex: 'firm', key: 'firm', title: t('Firm'), render: (text, row) => `${row?.firm?.name}`},
                        {dataIndex: 'name', key: 'name', title: t('Name'), render: (text, row) => `${row?.name}`},
                        {dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                                <Space>
                                    <a key="edit" href={`/app/system/cash-registers/${row.id}/edit`}>{t('edit')}</a>
                                </Space>
                            )},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}